import { Component, HostListener, OnInit } from '@angular/core'
import { BehaviourSettingServices } from '../../../../../services/BehaviourSetting.services'
import { FormBuilder } from '@angular/forms'

@Component({
    selector: 'app-modal-detail-behavior-form-setting',
    templateUrl: './modal-detail-behavior-form-setting.component.html',
    styleUrls: [
        './modal-detail-behavior-form-setting.component.css',
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/main-view.component.css',
    ],
})
export class ModalDetailBehaviorFormSettingComponent implements OnInit {

    // option_detail: any = 'hidden';
    levelMultiIndex: any
    index: any

    arrFormSetting: any[] = []
    jsonFormSetting: any = {}
    arrForModal: any[] = []
    i: any = 0

    arrStatusShow: any[] = []
    option: any

    arrMultipleItem: any[] = []

    statusDetailForm: any = {}


    title: String = ''
    type: any = ''
    isCondition: Boolean = false
    isListField: Boolean = false
    conditionTarget: any
    conditionValue: any
    schemaType: any
    schemaUiConditionType: any
    schemaUiType: any

    arrIdMultipleItem: any[] = []
    jsonIdentify: any = {}
    oldId: any
    level: any
    idConditionTarget: any = ''
    schemaOptionDate: any
    schemaArrOptionSelect: any[] = []
    id: any
    activeButton: any[] = ['hidden', 'hidden', 'hidden', 'hidden', 'hidden', 'hidden', 'hidden']
    activeSchemaOptionDate: any[] = ['hidden', 'hidden', 'hidden']
    top: any = 10
    right: any = 2.5
    bottom: any = 2
    left: any = 5
    width: any = 90
    numberMuti: any = 2
    opacity: any = -0.5

    arrSelect: any[] = []
    oldIndex: any

    firstJson: any = {}
    firstSchemaType: any
    firstSchemaOptionDate: any
    firstSchemaOptionSelect: any[] = []
    firstSchema: any = {}
    firstType: any = {}
    firstConditionTarget: any
    firstConditionValue: any
    optionConditionValue: any[] = []

    firstUiConditionType: any
    firstUiType: any
    firstProperties: any[] = []

    tabArray: any
    view: any = 'detail-form-setting'

    toViewShowModal: any
    state: any
    firstTitle: any
    firstIsCondition: any
    firstIsField: any
    firstArrFormSetting: any[] = []

    constructor(private formBuilder: FormBuilder,
                public behaviourSettingServices: BehaviourSettingServices) {
    }

    ngOnInit() {
        this.get()
        this.getTabName()
        this.behaviourSettingServices.emitChangeValueConditionTarget(null)
        this.behaviourSettingServices.emitChangeValueConditionValue(null)
        this.conditionTarget = ''
        this.behaviourSettingServices.changeEmittedValueConditionTarget$.subscribe(value => {
            if (value != null && value['conditionTarget'] != undefined && value['identify'] != undefined) {
                if (value['identify'] == this.levelMultiIndex) {
                    this.conditionTarget = value['conditionTarget']
                    this.jsonFormSetting['conditionTarget'] = this.conditionTarget['propertyName']
                    this.jsonFormSetting['conditionValue'] = ''
                    this.conditionValue = {}
                    this.emitArrFormSetting()
                    if (this.conditionTarget['schema']) {
                        this.optionConditionValue = this.conditionTarget['schema']['options']
                    }
                } else {
                    this.conditionTarget = ''
                    this.behaviourSettingServices.emitChangeValueConditionTarget(null)
                }
            }
        })
        this.behaviourSettingServices.changeEmittedValueConditionValue$.subscribe(value => {
            if (value && value['conditionValue'] != undefined && value['identify'] != undefined) {
                if (value['identify'] == this.levelMultiIndex) {
                    this.conditionValue = value['conditionValue']
                    this.jsonFormSetting['conditionValue'] = this.conditionValue['_id']
                    this.emitArrFormSetting()
                } else {
                    this.conditionValue = ''
                    this.behaviourSettingServices.emitChangeValueConditionValue(null)
                }
            }
        })
        this.behaviourSettingServices.changeEmittedState$.subscribe(infoState => {
            if (infoState != null && infoState != undefined && infoState['state'] != undefined) {
                this.state = infoState['state']
            }
        })
        this.getStatusFormInTimeline()
        this.getStatusFormSetting()
    }

    getStatusFormInTimeline() {
        this.behaviourSettingServices.changeEmittedIsActiveModalFormInTimeline$.subscribe(status => {
            if (status != null && status != undefined && status['status'] != undefined) {
                if (status['status'] == 'active') {
                    this.toViewShowModal = 'form-in-timeline'
                }
            }
        })
    }

    getStatusFormSetting() {
        this.behaviourSettingServices.changeEmittedStatusFormSetting$.subscribe(option => {
            if (option != null && option['statusFormSetting'] != undefined) {
                if (option['statusFormSetting'] == 'active') {
                    this.toViewShowModal = 'form-setting'
                }
            }
        }, error1 => {
        })
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        const keyPressed = event.keyCode
        const showView: any = this.behaviourSettingServices.returnView()
        if (showView != '' && showView == this.view) {
            if (keyPressed === 27) {
                if (event) {
                    event.preventDefault()
                }
                this.closeModal()
            } else if (keyPressed == 13) {
                event.preventDefault()
            }
        }
    }

    getTabName() {
        this.behaviourSettingServices.changeEmittedFormSetting$.subscribe(option => {
            if (option != null && option['formSetting'] != undefined) {
                this.tabArray = option['formSetting']
            }
        })
    }

    getStyle(index) {
        const tmpIndex: any = index + 1

        // if (this.tabArray != 'timeline') {
        //     tmpIndex = index + 1;
        // } else {
        //     tmpIndex = index + 2;
        // }
        const surplus: any = tmpIndex % 3
        let tmpLeft: any = this.left
        let tmpRight: any = this.right
        let tmpBottom: any = this.bottom
        let tmpTop: any = 0

        tmpLeft = surplus * this.numberMuti
        tmpRight = this.right + surplus * this.numberMuti
        tmpBottom = this.bottom + surplus * this.numberMuti
        tmpTop = surplus * this.numberMuti
        let style: any = {
            'left': '0%',
        }
        if (surplus != 0) {
            style = {
                'left': tmpLeft + '%',
                'top': tmpTop + '%',
            }
            return style
        }
        return style
    }

    getStyleOpacity(index) {
        const surplus: any = index % 3
        let opacity: any = 0.2
        let style: any = {
            'opacity': opacity,
        }
        if (surplus == 2) {
            opacity = 0.1
            style = {
                'opacity': opacity,
            }
            return style
        }
        return style
    }

    changeOptionSelect(event, index) {
        const value: any = event.target.value
        const json: any = this.schemaArrOptionSelect[index]
        json['title'] = value
        this.schemaArrOptionSelect[index] = json
        const tmpChema = this.jsonFormSetting['schema']
        tmpChema['options'] = this.schemaArrOptionSelect
        this.jsonFormSetting['schema'] = tmpChema
        this.emitArrFormSetting()
        //
    }

    removeOptionSelect(index) {
        if (this.schemaArrOptionSelect.length > 1) {
            this.schemaArrOptionSelect.splice(index, 1)
            const tmpChema = this.jsonFormSetting['schema']
            tmpChema['options'] = this.schemaArrOptionSelect
            this.jsonFormSetting['schema'] = tmpChema
            this.emitArrFormSetting()
        } else {
            this.schemaArrOptionSelect = [
                {
                    _id: new Date().getTime().toString(),
                    title: '',
                },
            ]
        }
    }

    addOptionSelect() {
        const newItem: any = {}
        newItem['_id'] = new Date().getTime().toString()
        newItem['title'] = ''
        this.schemaArrOptionSelect.push(newItem)
        const tmpChema = this.jsonFormSetting['schema']
        tmpChema['options'] = this.schemaArrOptionSelect
        this.jsonFormSetting['schema'] = tmpChema
        this.emitArrFormSetting()
    }

    moveUpOptionSelect(index) {
        const nextIndex: any = index - 1
        if (nextIndex >= 0) {
            const jsonIndex: any = this.schemaArrOptionSelect[index]
            const jsonNextIndex: any = this.schemaArrOptionSelect[nextIndex]
            this.schemaArrOptionSelect[index] = jsonNextIndex
            this.schemaArrOptionSelect[nextIndex] = jsonIndex
        }
        const tmpChema = this.jsonFormSetting['schema']
        tmpChema['options'] = this.schemaArrOptionSelect
        this.jsonFormSetting['schema'] = tmpChema
        this.emitArrFormSetting()
    }

    moveDownOptionSelect(index) {
        const nextIndex: any = index + 1
        if (nextIndex < this.schemaArrOptionSelect.length) {
            const jsonIndex: any = this.schemaArrOptionSelect[index]
            const jsonNextIndex: any = this.schemaArrOptionSelect[nextIndex]
            this.schemaArrOptionSelect[index] = jsonNextIndex
            this.schemaArrOptionSelect[nextIndex] = jsonIndex
        }
        const tmpChema = this.jsonFormSetting['schema']
        tmpChema['options'] = this.schemaArrOptionSelect
        this.jsonFormSetting['schema'] = tmpChema
        this.emitArrFormSetting()
    }

    schemaTypeOptionDate(index, optionDate) {
        if (this.activeSchemaOptionDate[index] == 'active') {
            this.activeSchemaOptionDate[index] = 'hidden'
            this.schemaOptionDate = ''
        } else {
            this.activeSchemaOptionDate[index] = 'active'
            this.schemaOptionDate = optionDate
        }
        const uiOptionDateTmp = {}
        uiOptionDateTmp['behavior'] = this.schemaOptionDate
        const tmpSchema = this.jsonFormSetting['schema']
        tmpSchema['uiOptions'] = uiOptionDateTmp
        this.jsonFormSetting['schema'] = tmpSchema
        this.activeSchemaOptionDate.forEach((el, i) => {
            if (i != index) {
                this.activeSchemaOptionDate[i] = 'hidden'
            }
        })
    }

    addItem() {
        // if (this.arrFormSetting )
        //
        const newItem: any = {}
        newItem['conditionTarget'] = ''
        newItem['isCondition'] = false
        newItem['isListField'] = false
        newItem['propertyName'] = new Date().getTime().toString()
        // newItem['multipleItem'] = [];
        newItem['schema'] = {}
        newItem['title'] = ''
        newItem['type'] = ''
        newItem['level'] = this.level
        newItem['parent'] = this.jsonFormSetting['propertyName']
        this.arrFormSetting.push(newItem)
        const arrMulti: any[] = (this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['items']) ? this.jsonFormSetting['schema']['items']['properties'] : []
        const json = {}
        json['propertyName'] = newItem['propertyName']
        arrMulti.push(json)
        const jsonProperty: any = {}
        jsonProperty['properties'] = arrMulti
        jsonProperty['type'] = 'object'
        const jsonItem = this.jsonFormSetting['schema'] ? this.jsonFormSetting['schema'] : {}
        jsonItem['items'] = jsonProperty
        this.jsonFormSetting['schema'] = jsonItem
        this.arrFormSetting[this.index] = this.jsonFormSetting
        this.arrMultipleItem.push(newItem)
        const emitArr: any = {}
        emitArr['arrFormSetting'] = this.arrFormSetting
        emitArr['option'] = this.tabArray
        this.behaviourSettingServices.emitChangeArrFormSetting(emitArr)
    }

    removeJson() {
        this.jsonFormSetting['title'] = ''
        this.jsonFormSetting['type'] = ''
        this.jsonFormSetting['conditionTarget'] = ''
        this.jsonFormSetting['isCondition'] = false
        this.jsonFormSetting['isListField'] = false
        // this.jsonFormSetting['multipleItem'] = [];
        this.jsonFormSetting['schema'] = {}
        this.jsonFormSetting['level'] = this.level
        this.arrFormSetting[this.index] = this.jsonFormSetting
        const emitArrAll: any = {}
        emitArrAll['arrFormSetting'] = this.arrFormSetting
        emitArrAll['option'] = this.tabArray
        this.behaviourSettingServices.emitChangeArrFormSetting(emitArrAll)
        this.emitChangeElement()
    }

    onSave() {
        // event.preventDefault();
        const emitState: any = {}
        emitState['state'] = 'old'
        this.behaviourSettingServices.emitChangeState(emitState)
        this.arrIdMultipleItem = []
        this.jsonFormSetting['title'] = this.title
        this.jsonFormSetting['conditionTarget'] = this.conditionTarget ? this.conditionTarget['propertyName'] : ''
        this.jsonFormSetting['isCondition'] = this.isCondition
        this.jsonFormSetting['isListField'] = this.isListField
        if (this.type == 'normal') {
            this.jsonFormSetting['type'] = null
        } else {
            this.jsonFormSetting['type'] = this.type
        }
        // this.jsonFormSetting['multipleItem'] = this.jsonFormSetting['multipleItem'];
        const jsonProperty = {}
        jsonProperty['properties'] = this.arrMultipleItem
        jsonProperty['type'] = 'object'
        const jsonSchema = {}
        if (this.arrMultipleItem.length > 0) {
            jsonSchema['items'] = jsonProperty
        }
        jsonSchema['type'] = this.schemaType ? this.schemaType : ''
        jsonSchema['uiConditionType'] = this.schemaUiConditionType ? this.schemaUiConditionType : null
        jsonSchema['uiType'] = this.schemaUiType ? this.schemaUiType : null
        const uiOptionDate = {}
        uiOptionDate['behavior'] = this.schemaOptionDate ? this.schemaOptionDate : ''
        jsonSchema['uiOptions'] = uiOptionDate
        if (this.schemaArrOptionSelect && this.schemaArrOptionSelect.length > 0) {
            jsonSchema['options'] = this.schemaArrOptionSelect
        }
        this.jsonFormSetting['schema'] = jsonSchema
        this.arrFormSetting[this.index] = this.jsonFormSetting

        const emitArrAll: any = {}
        emitArrAll['arrFormSetting'] = this.arrFormSetting
        emitArrAll['option'] = this.tabArray
        this.behaviourSettingServices.emitChangeArrFormSetting(emitArrAll)
        this.behaviourSettingServices.emitChangeValueConditionTarget(null)

        const arrUndo = this.behaviourSettingServices.returnArrUndo()
        let arrEmitUndo: any[] = []
        if (arrUndo && arrUndo['undo']) {
            arrEmitUndo = arrUndo['undo']
        }

        const arrfindUndo = arrEmitUndo.filter(el => {
            return el['propertyName'] == this.jsonFormSetting['propertyName']
        })
        arrfindUndo.forEach(el => {
            const findIndexUndo = arrEmitUndo.find(item => {
                return item['propertyName'] == this.jsonFormSetting['propertyName']
            })
            arrEmitUndo[findIndexUndo] = this.jsonFormSetting
        })

        const emitUndo = {}
        emitUndo['undo'] = arrEmitUndo
        this.behaviourSettingServices.emitChangeArrFormSettingUndo(emitUndo)

        this.emitChangeElement()
    }

    emitChangeElement() {
        const status: any = 'statusDetailForm-' + this.levelMultiIndex
        this.statusDetailForm[status] = 'hidden'
        this.behaviourSettingServices.emitChangeStatusDetailFormSetting(this.statusDetailForm)

        const countLevel: any = {}
        countLevel['identify'] = this.jsonFormSetting['parent']
        this.behaviourSettingServices.emitChangeCountLevel(countLevel)

        const newLevel: any = this.level - 1
        const emitLevel: any = {}
        emitLevel['level'] = newLevel
        this.behaviourSettingServices.emitChangeLevel(emitLevel)
        this.behaviourSettingServices.emitChangeValueConditionTarget(null)
    }

    onChangeType(option) {
        this.type = option
        this.jsonFormSetting['type'] = this.type
        this.emitArrFormSetting()
    }

    onChangeTitle(e) {
        this.jsonFormSetting['title'] = e.target.value
        this.emitArrFormSetting()
    }

    changeIsCondition(e) {
        this.jsonFormSetting['isCondition'] = !this.isCondition
        this.emitArrFormSetting()
    }

    changeIsListField(e) {
        this.jsonFormSetting['isListField'] = !this.isListField
        this.emitArrFormSetting()
    }

    emitArrFormSetting() {
        this.arrFormSetting[this.index] = this.jsonFormSetting
        const emitArr: any = {}
        emitArr['arrFormSetting'] = this.arrFormSetting
        emitArr['option'] = this.tabArray
        this.behaviourSettingServices.emitChangeArrFormSetting(emitArr)
    }

    get() {
        this.behaviourSettingServices.emitChangeValueConditionTarget(null)
        this.behaviourSettingServices.changeEmittedLevel$.subscribe(level => {
            this.conditionTarget = {}
            this.conditionValue = {}
            this.optionConditionValue = []
            if (level != null && level['level'] != undefined) {
                this.level = level['level']
                // this.behaviourSettingServices.changeEmittedCountLevelItem$.subscribe(countLevel => {
                const countLevel: any = this.behaviourSettingServices.getLevel()
                this.oldIndex = this.levelMultiIndex
                if (countLevel != null && countLevel['identify'] != undefined) {
                    this.levelMultiIndex = countLevel['identify']
                    // this.behaviourSettingServices.changeEmittedStatusDetailFormSetting$.subscribe(status => {
                    const status: any = this.behaviourSettingServices.getStatusDetail()
                    this.arrStatusShow = []
                    this.arrForModal = []
                    this.option = ''
                    this.activeSchemaOptionDate = ['hidden', 'hidden', 'hidden']
                    this.activeButton = ['hidden', 'hidden', 'hidden', 'hidden', 'hidden', 'hidden', 'hidden']
                    this.schemaOptionDate = ''
                    this.schemaType = ''
                    this.type = ''
                    const tabStatus: any = 'statusDetailForm-' + this.levelMultiIndex
                    if (status != null && status[tabStatus] != undefined) {
                        this.statusDetailForm = status
                        const option_detail: any = status[tabStatus]
                        this.arrStatusShow.push(option_detail)
                        for (this.i = 0; this.i < this.level; this.i++) {
                            this.arrForModal.push(this.i)
                        }
                    }
                    // });
                    // this.behaviourSettingServices.changeEmittedArrFormSetting$.subscribe(arr => {
                    const arr: any = this.behaviourSettingServices.getArrFormSetting()
                    if (arr != null && arr['arrFormSetting'] != undefined) {
                        this.arrFormSetting = arr['arrFormSetting']
                        this.firstArrFormSetting = $.extend(true, [], this.arrFormSetting)
                        if (this.arrFormSetting.length > 0) {
                            this.index = this.arrFormSetting.findIndex(el => {
                                return el && el['propertyName'] == this.levelMultiIndex
                            })
                            this.jsonFormSetting = this.arrFormSetting[this.index]
                            if (this.jsonFormSetting != undefined) {
                                if (this.state == 'new') {
                                    const arrUndo = this.behaviourSettingServices.returnArrUndo()
                                    let arrEmitUndo: any[] = []
                                    if (arrUndo && arrUndo['undo']) {
                                        arrEmitUndo = jQuery.extend(true, [], arrUndo['undo'])
                                    }
                                    const jsonUndo = this.firstArrFormSetting[this.index]
                                    const check = arrEmitUndo.findIndex(el => {
                                        return el['propertyName'] == jsonUndo['propertyName']
                                    })
                                    if (check == -1) {
                                        arrEmitUndo.push(jsonUndo)
                                    } else {
                                        arrEmitUndo[check] = jsonUndo
                                    }
                                    const emitUndo = {}
                                    emitUndo['undo'] = arrEmitUndo
                                    this.behaviourSettingServices.emitChangeArrFormSettingUndo(emitUndo)
                                }

                                this.title = this.jsonFormSetting['title'] ? this.jsonFormSetting['title'] : ''
                                if (this.jsonFormSetting['schema'] != undefined && this.jsonFormSetting['schema']['uiType'] != undefined) {
                                    this.firstUiType = this.jsonFormSetting['schema']['uiType']
                                    this.schemaUiType = this.jsonFormSetting['schema']['uiType']
                                } else {
                                    this.schemaUiType = null
                                }
                                if (this.jsonFormSetting['schema'] != undefined && this.jsonFormSetting['schema']['uiConditionType'] != undefined) {
                                    this.firstUiConditionType = this.jsonFormSetting['schema']['uiConditionType']
                                    this.schemaUiConditionType = this.jsonFormSetting['schema']['uiConditionType']
                                } else {
                                    this.schemaUiConditionType = null
                                }
                                this.schemaType = this.jsonFormSetting['schema'] ? this.jsonFormSetting['schema']['type'] : ''
                                if (this.state != 'new') {
                                    this.firstSchemaType = this.jsonFormSetting['schema'] ? this.jsonFormSetting['schema']['type'] : ''
                                    if (this.firstUiType == 'dialog' && this.schemaType == 'array') {
                                        this.firstUiType = 'button'
                                        this.schemaUiType = 'button'
                                        this.firstUiConditionType = null
                                        this.schemaUiConditionType = null
                                        this.schemaType = 'array'
                                        this.firstSchemaType = 'array'
                                        this.activeButton[1] = 'active'
                                        this.activeButton.forEach((el, i) => {
                                            if (i != 1) {
                                                this.activeButton[i] = 'hidden'
                                            }
                                        })
                                    }
                                    this.arrMultipleItem = []
                                    const arrChildren: any[] = (this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['items']) ? this.jsonFormSetting['schema']['items']['properties'] : []
                                    if (arrChildren && arrChildren.length > 0) {
                                        this.activeButton = ['hidden', 'hidden', 'hidden', 'hidden', 'hidden', 'hidden', 'hidden']
                                        this.firstProperties = []
                                        const thi = this
                                        this.firstProperties = $.extend(true, [], arrChildren)
                                        this.selectPattern(6, 'multipleItem')
                                    } else {
                                        this.arrMultipleItem = []
                                        this.firstProperties = []
                                    }
                                } else {
                                    if (this.firstUiType == 'dialog' && this.schemaType == 'array') {
                                        if (this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['items'] && this.jsonFormSetting['schema']['items']['properties']) {
                                            this.arrMultipleItem = []
                                            const arrChildren: any[] = this.jsonFormSetting['schema']['items']['properties']
                                            this.arrMultipleItem = []
                                            if (arrChildren && arrChildren.length > 0) {
                                                arrChildren.forEach(tmp1 => {
                                                    const arrTmp = this.arrFormSetting.filter(tmp2 => {
                                                        return tmp2['propertyName'] == tmp1['propertyName']
                                                    })
                                                    arrTmp.forEach(el => {
                                                        this.arrMultipleItem.push(el)
                                                    })
                                                })
                                            } else {
                                                this.arrMultipleItem = []
                                            }
                                        } else {
                                            this.arrMultipleItem = []
                                        }
                                    } else {
                                        this.arrMultipleItem = []
                                    }
                                    this.schemaArrOptionSelect = [
                                        {
                                            _id: new Date().getTime().toString(),
                                            title: '',
                                        },
                                    ]
                                    if (this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['uiConditionType'] && this.jsonFormSetting['schema']['uiConditionType'] == 'partial') {
                                        if (this.jsonFormSetting['schema']['uiType'] == 'multi') {
                                            this.activeButton[3] = 'active'
                                            this.activeButton.forEach((el, i) => {
                                                if (i != 3) {
                                                    this.activeButton[i] = 'hidden'
                                                }
                                            })
                                        } else {
                                            this.activeButton[2] = 'active'
                                            this.activeButton.forEach((el, i) => {
                                                if (i != 2) {
                                                    this.activeButton[i] = 'hidden'
                                                }
                                            })
                                        }
                                    } else if (this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['uiType'] && this.jsonFormSetting['schema']['uiType'] == 'image') {
                                        this.activeButton[5] = 'active'
                                        this.activeButton.forEach((el, i) => {
                                            if (i != 5) {
                                                this.activeButton[i] = 'hidden'
                                            }
                                        })
                                    } else if (this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['type'] && this.jsonFormSetting['schema']['type'] == 'date') {
                                        this.activeButton[4] = 'active'
                                        this.activeButton.forEach((el, i) => {
                                            if (i != 4) {
                                                this.activeButton[i] = 'hidden'
                                            }
                                        })
                                        if (this.jsonFormSetting['schema']['uiOptions'] && this.jsonFormSetting['schema']['uiOptions']['behavior']) {
                                            this.schemaOptionDate = (this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['uiOptions'] && this.jsonFormSetting['schema']['uiOptions']['behavior']) ? this.jsonFormSetting['schema']['uiOptions']['behavior'] : ''
                                            switch (this.schemaOptionDate) {
                                                case 'birthdaySingle':
                                                    this.activeSchemaOptionDate[0] = 'active'
                                                    this.activeSchemaOptionDate[1] = 'hidden'
                                                    this.activeSchemaOptionDate[2] = 'hidden'
                                                    break
                                                case 'recentToday':
                                                    this.activeSchemaOptionDate[1] = 'active'
                                                    this.activeSchemaOptionDate[0] = 'hidden'
                                                    this.activeSchemaOptionDate[2] = 'hidden'
                                                    break
                                                case 'recentSingle':
                                                    this.activeSchemaOptionDate[2] = 'active'
                                                    this.activeSchemaOptionDate[1] = 'hidden'
                                                    this.activeSchemaOptionDate[0] = 'hidden'
                                                    break
                                                default:
                                                    this.activeSchemaOptionDate[0] = 'hidden'
                                                    this.activeSchemaOptionDate[1] = 'hidden'
                                                    this.activeSchemaOptionDate[2] = 'hidden'
                                                    break
                                            }
                                        } else {
                                            this.activeSchemaOptionDate[0] = 'hidden'
                                            this.activeSchemaOptionDate[1] = 'hidden'
                                            this.activeSchemaOptionDate[2] = 'hidden'
                                        }
                                    } else if (this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['uiType'] && this.jsonFormSetting['schema']['uiType'] == 'button') {
                                        if (this.jsonFormSetting['schema']['type'] == 'array') {
                                            this.activeButton[1] = 'active'
                                            this.activeButton.forEach((el, i) => {
                                                if (i != 1) {
                                                    this.activeButton[i] = 'hidden'
                                                }
                                            })
                                        } else {
                                            this.activeButton[0] = 'active'
                                            this.activeButton.forEach((el, i) => {
                                                if (i != 0) {
                                                    this.activeButton[i] = 'hidden'
                                                }
                                            })
                                        }
                                    } else if (this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['uiType'] == 'dialog' ||
                                        this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['type'] == 'array' && this.jsonFormSetting['schema']['uiType'] != 'button') {
                                        // this.firstUiType = 'button';
                                        // this.schemaUiType = 'button';
                                        // this.firstUiConditionType = null;
                                        // this.schemaUiConditionType = null;
                                        // this.schemaType = 'array';
                                        // this.firstSchemaType = 'array';
                                        this.activeButton[1] = 'active'
                                        this.activeButton.forEach((el, i) => {
                                            if (i != 1) {
                                                this.activeButton[i] = 'hidden'
                                            }
                                        })
                                    } else {
                                        this.firstUiType = null
                                        this.schemaUiType = null
                                        this.firstUiConditionType = null
                                        this.schemaUiConditionType = null
                                        this.schemaType = null
                                        this.firstSchemaType = null
                                        this.activeButton.forEach((el, i) => {
                                            this.activeButton[i] = 'hidden'
                                        })
                                    }
                                }
                                this.firstSchemaOptionSelect = []
                                this.firstSchema = this.jsonFormSetting['schema']
                                if (this.jsonFormSetting['schema'] != undefined && this.jsonFormSetting['schema']['options'] != undefined) {
                                    this.schemaArrOptionSelect = this.jsonFormSetting['schema']['options']
                                    if (this.schemaArrOptionSelect.length > 0) {
                                        this.firstSchemaOptionSelect = $.extend(true, [], this.schemaArrOptionSelect)
                                    } else {
                                        this.schemaArrOptionSelect = [
                                            {
                                                _id: new Date().getTime().toString(),
                                                title: '',
                                            },
                                        ]
                                        this.firstSchemaOptionSelect = [
                                            {
                                                _id: new Date().getTime().toString(),
                                                title: '',
                                            },
                                        ]
                                    }
                                } else {
                                    this.schemaArrOptionSelect = [
                                        {
                                            _id: new Date().getTime().toString(),
                                            title: '',
                                        },
                                    ]
                                }
                                if (this.jsonFormSetting['type'] == 'separator') {
                                    this.type = 'separator'
                                } else if (this.jsonFormSetting['type'] == '') {
                                    this.type = ''
                                } else if (this.jsonFormSetting['type'] == null) {
                                    this.type = 'normal'
                                } else {
                                    this.type = ''
                                }
                                // this.type = (this.jsonFormSetting['type'] != undefined && this.jsonFormSetting['type'] != '') ? this.jsonFormSetting['type'] : '';
                                this.firstConditionTarget = this.jsonFormSetting['conditionTarget']
                                this.firstConditionValue = this.jsonFormSetting['conditionValue']
                                this.firstType = jQuery.extend(true, '', this.type)
                                this.isCondition = this.jsonFormSetting['isCondition'] ? this.jsonFormSetting['isCondition'] : false
                                this.firstIsCondition = this.jsonFormSetting['isCondition'] ? this.jsonFormSetting['isCondition'] : false
                                this.firstIsField = this.jsonFormSetting['isListField'] ? this.jsonFormSetting['isListField'] : false
                                this.isListField = this.jsonFormSetting['isListField'] ? this.jsonFormSetting['isListField'] : false
                                this.idConditionTarget = this.jsonFormSetting['conditionTarget'] ? this.jsonFormSetting['conditionTarget'] : ''
                                const idConditionValue = this.jsonFormSetting['conditionValue'] ? this.jsonFormSetting['conditionValue'] : ''
                                const tmpArrFormSetting: any[] = this.arrFormSetting
                                const tmpJsonFormSetting: any = this.jsonFormSetting

                                if (this.idConditionTarget != undefined && this.idConditionTarget != '') {
                                    const target: any = tmpArrFormSetting.find(function(el) {
                                        return el && el['propertyName'] == tmpJsonFormSetting['conditionTarget']
                                    })

                                    if (target != undefined) {
                                        this.conditionTarget = target
                                        this.optionConditionValue = (target['schema'] && target['schema']['options']) ? target['schema']['options'] : []
                                        if (idConditionValue != '') {
                                            if (this.optionConditionValue.length > 0) {
                                                const findConditionValue = this.optionConditionValue.find(function(valueConditionValue) {
                                                    return valueConditionValue['_id'] == idConditionValue
                                                })
                                                this.conditionValue = findConditionValue
                                            } else {
                                                this.conditionValue = {}
                                            }
                                        } else {
                                            this.conditionValue = {}
                                        }
                                    }
                                } else {
                                    this.conditionTarget = {}
                                }
                            }
                        }
                    }
                    // });
                }
                // });
            }
        })

    }

    openModal(id) {
        this.arrSelect[this.levelMultiIndex] = this.schemaArrOptionSelect
        const newId: any = id
        const status: any = 'statusDetailForm-' + newId

        this.statusDetailForm[status] = 'active'
        this.behaviourSettingServices.emitChangeStatusDetailFormSetting(this.statusDetailForm)

        const countLevel: any = {}
        countLevel['identify'] = newId


        const newLevel: any = this.level + 1
        const emitLevel: any = {}
        emitLevel['level'] = newLevel

        this.behaviourSettingServices.emitChangeCountLevel(countLevel)
        this.behaviourSettingServices.emitChangeLevel(emitLevel)
        this.behaviourSettingServices.emitChangeValueConditionTarget(null)
        this.behaviourSettingServices.emitChangeValueConditionValue(null)
        const emitView: any = {}
        emitView['view'] = 'detail-form-setting'
        this.behaviourSettingServices.emitChangeView(emitView)
    }

    selectPattern(index, option) {
        this.arrMultipleItem = []
        if (this.activeButton[index] == 'active') {
            this.activeButton[index] = 'hidden'
        } else {
            this.activeButton[index] = 'active'
        }

        switch (option) {
            case 'singleSelect':
                this.schemaType = 'string'
                this.schemaUiConditionType = null
                this.schemaUiType = 'button'
                break
            case 'multipleSelect':
                this.schemaType = 'array'
                this.schemaUiConditionType = null
                this.schemaUiType = 'button'
                break
            case 'stringSingleLine':
                this.schemaType = 'string'
                this.schemaUiConditionType = 'partial'
                this.schemaUiType = null
                break
            case 'stringMultipleLines':
                this.schemaType = 'string'
                this.schemaUiConditionType = 'partial'
                this.schemaUiType = 'multi'
                break
            case 'date':
                this.schemaType = 'date'
                this.schemaUiConditionType = null
                this.schemaUiType = null
                break
            case 'image':
                this.schemaType = 'object'
                this.schemaUiConditionType = null
                this.schemaUiType = 'image'
                break
            case 'multipleItem':
                this.schemaType = 'array'
                this.schemaUiConditionType = null
                this.schemaUiType = 'dialog'
                break
            default:
                break
        }
        this.activeButton.forEach((el, i) => {
            if (i != index) {
                this.activeButton[i] = 'hidden'
            }
        })
        if (option == 'multipleItem') {
            if (this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['items'] && this.jsonFormSetting['schema']['items']['properties']) {
                const arrChildren: any[] = this.jsonFormSetting['schema']['items']['properties']
                if (arrChildren && arrChildren.length > 0) {
                    arrChildren.forEach(tmp1 => {
                        const arrTmp = this.arrFormSetting.filter(tmp2 => {
                            return tmp2['propertyName'] == tmp1['propertyName']
                        })
                        arrTmp.forEach(el => {
                            this.arrMultipleItem.push(el)
                        })
                    })
                }
            }
        }
        if (option == 'singleSelect' || option == 'multipleSelect') {
            if (this.jsonFormSetting['schema'] != undefined && this.jsonFormSetting['schema']['options'] != undefined && this.jsonFormSetting['schema']['options'].length > 0) {
                this.schemaArrOptionSelect = this.jsonFormSetting['schema']['options']
            } else {
                if (this.oldIndex != undefined) {
                    if (this.levelMultiIndex > this.oldIndex) {
                        this.schemaArrOptionSelect = [
                            {
                                _id: new Date().getTime().toString(),
                                title: '',
                            },
                        ]
                    } else {
                        if (this.arrSelect.length > 0 && this.arrSelect[this.levelMultiIndex]) {
                            this.schemaArrOptionSelect = this.arrSelect[this.levelMultiIndex]
                        } else {
                            this.schemaArrOptionSelect = [
                                {
                                    _id: new Date().getTime().toString(),
                                    title: '',
                                },
                            ]
                        }
                    }
                } else {
                    this.schemaArrOptionSelect = [
                        {
                            _id: new Date().getTime().toString(),
                            title: '',
                        },
                    ]
                }
            }
        }
        if (option == 'date') {
            if (this.jsonFormSetting['schema'] && this.jsonFormSetting['schema']['uiOptions'] && this.jsonFormSetting['schema']['uiOptions']['behavior']) {
                this.schemaOptionDate = this.jsonFormSetting['schema']['uiOptions']['behavior']
                switch (this.schemaOptionDate) {
                    case 'birthdaySingle':
                        this.activeSchemaOptionDate[0] = 'active'
                        this.activeSchemaOptionDate[1] = 'hidden'
                        this.activeSchemaOptionDate[2] = 'hidden'
                        break
                    case 'recentToday':
                        this.activeSchemaOptionDate[1] = 'active'
                        this.activeSchemaOptionDate[0] = 'hidden'
                        this.activeSchemaOptionDate[2] = 'hidden'
                        break
                    case 'recentSingle':
                        this.activeSchemaOptionDate[2] = 'active'
                        this.activeSchemaOptionDate[1] = 'hidden'
                        this.activeSchemaOptionDate[0] = 'hidden'
                        break
                    default:
                        break
                }
            } else {
                this.schemaOptionDate = ''
                this.activeSchemaOptionDate[1] = 'hidden'
                this.activeSchemaOptionDate[0] = 'hidden'
                this.activeSchemaOptionDate[2] = 'hidden'
            }
        }
    }

    closeModal() {
        const emitState: any = {}
        emitState['state'] = 'old'
        this.behaviourSettingServices.emitChangeState(emitState)
        this.schemaArrOptionSelect = this.firstSchemaOptionSelect
        this.activeButton.forEach((el, i) => {
            this.activeButton[i] = 'hidden'
        })
        // if (this.firstSchema) {
        //     if (this.firstSchemaOptionSelect.length > 0) {
        //         this.firstSchema['options'] = this.firstSchemaOptionSelect;
        //     }

        //     if (this.firstProperties.length > 0) {
        //         const tmpPro = {};
        //         console.log('this.firstProperties 121: ', this.firstProperties);
        //         tmpPro['properties'] = this.firstProperties.filter(function(el) {
        //             return (el['title'] && el['title'] != '');
        //         });
        //         tmpPro['type'] = 'object';
        //         this.firstSchema['items'] = tmpPro;
        //     }
        //     if (this.firstSchema['type']) {
        //         this.firstSchema['type'] = this.firstSchemaType;
        //     }

        //     if (this.firstSchema['optionDate']) {
        //         this.firstSchema['optionDate'] = this.firstSchemaOptionDate;
        //     }
        //     this.jsonFormSetting['schema'] = this.firstSchema;
        // }

        // this.jsonFormSetting['type'] = this.firstType;
        // this.jsonFormSetting['conditionTarget'] = this.firstConditionTarget ? this.firstConditionTarget : '';
        // this.jsonFormSetting['conditionValue'] = this.firstConditionValue ? this.firstConditionValue : '';

        // this.jsonFormSetting['title'] = this.firstTitle ? this.firstTitle : '';
        // this.jsonFormSetting['isCondition'] = this.firstIsCondition;
        // this.jsonFormSetting['isListField'] = this.firstIsField;

        const arrJsonUndo = this.behaviourSettingServices.returnArrUndo()
        const arrUndo = arrJsonUndo['undo']
        const jsonUndo = arrUndo.find(el => {
            return el['propertyName'] == this.jsonFormSetting['propertyName']
        })
        this.jsonFormSetting = jsonUndo
        this.arrFormSetting[this.index] = this.jsonFormSetting
        const emitArr: any = {}
        emitArr['arrFormSetting'] = this.arrFormSetting
        emitArr['option'] = this.tabArray
        this.behaviourSettingServices.emitChangeArrFormSetting(emitArr)
        this.arrSelect[this.levelMultiIndex] = [
            {
                _id: new Date().getTime().toString(),
                title: '',
            },
        ]
        if (this.oldIndex == 0) {
            this.oldIndex = undefined
        }
        const status: any = 'statusDetailForm-' + this.levelMultiIndex
        this.statusDetailForm[status] = 'hidden'
        this.behaviourSettingServices.emitChangeStatusDetailFormSetting(this.statusDetailForm)

        const countLevel: any = {}
        countLevel['identify'] = this.jsonFormSetting ? this.jsonFormSetting['parent'] : ''
        this.behaviourSettingServices.emitChangeCountLevel(countLevel)

        const newLevel: any = this.level - 1
        const emitLevel: any = {}
        emitLevel['level'] = newLevel
        this.behaviourSettingServices.emitChangeLevel(emitLevel)
        this.behaviourSettingServices.emitChangeValueConditionTarget(null)
        this.behaviourSettingServices.emitChangeValueConditionValue(null)
        if (this.toViewShowModal == 'form-in-timeline') {
            if (newLevel == 1) {
                const emitView: any = {}
                emitView['view'] = 'form-in-timeline'
                this.behaviourSettingServices.emitChangeView(emitView)
            }
        } else if (this.toViewShowModal == 'form-setting') {
            if (newLevel == 0) {
                const emitView: any = {}
                emitView['view'] = 'form-setting'
                this.behaviourSettingServices.emitChangeView(emitView)
            }
        }
    }

    openModalConditionTarget() {
        const emitStatusTarget: any = {}
        emitStatusTarget['status'] = 'active'
        emitStatusTarget['selected'] = this.conditionTarget
        this.behaviourSettingServices.emitChangeStatusConditionTarget(emitStatusTarget)
        this.behaviourSettingServices.emitChangeValueConditionTarget(null)
        const emitView: any = {}
        emitView['view'] = 'condition-target'
        this.behaviourSettingServices.emitChangeView(emitView)
    }

    openModalConditionValue() {
        if (Object.keys(this.conditionTarget).length > 0 || Object.keys(this.conditionValue).length > 0) {
            const emitStatusTarget: any = {}
            emitStatusTarget['status'] = 'active'
            emitStatusTarget['selected'] = this.conditionValue
            emitStatusTarget['options'] = this.optionConditionValue
            this.behaviourSettingServices.emitChangeStatusConditionValue(emitStatusTarget)
            this.behaviourSettingServices.emitChangeValueConditionValue(null)
            const emitView: any = {}
            emitView['view'] = 'condition-value'
            this.behaviourSettingServices.emitChangeView(emitView)
        }
    }

    remove(index) {
        const json: any = this.arrMultipleItem[index]
        this.arrMultipleItem.splice(index, 1)
        this.arrIdMultipleItem = []
        this.arrMultipleItem.forEach(el => {
            this.arrIdMultipleItem.push(el['id'])
        })
        const ind: any = this.arrFormSetting.findIndex((el, i) => {
            return el['id'] == json['id']
        })
        if (ind != -1) {
            this.arrFormSetting.splice(ind, 1)
        }
        this.jsonFormSetting['multipleItem'] = this.arrIdMultipleItem
        this.arrFormSetting[this.index] = this.jsonFormSetting
        const emitArrAll: any = {}
        emitArrAll['arrFormSetting'] = this.arrFormSetting
        emitArrAll['option'] = this.tabArray
        this.behaviourSettingServices.emitChangeArrFormSetting(emitArrAll)
    }

    moveUp(index) {
        const nextIndex: any = index - 1
        if (nextIndex >= 0) {
            const jsonIndex = this.arrMultipleItem.find((el, i) => {
                return i == index
            })
            const jsonNextIndex = this.arrMultipleItem.find((el, i) => {
                return i == nextIndex
            })
            this.arrMultipleItem[index] = jsonNextIndex
            this.arrMultipleItem[nextIndex] = jsonIndex
            this.arrIdMultipleItem = []
            this.arrMultipleItem.forEach(el => {
                this.arrIdMultipleItem.push(el['id'])
            })
            this.jsonFormSetting['multipleItem'] = this.arrIdMultipleItem
        }
    }

    moveDown(index) {
        const nextIndex: any = index + 1
        if (nextIndex < this.arrMultipleItem.length) {
            const jsonIndex = this.arrMultipleItem.find((el, i) => {
                return i == index
            })
            const jsonNextIndex = this.arrMultipleItem.find((el, i) => {
                return i == nextIndex
            })
            this.arrMultipleItem[index] = jsonNextIndex
            this.arrMultipleItem[nextIndex] = jsonIndex
            this.arrIdMultipleItem = []
            this.arrMultipleItem.forEach(el => {
                this.arrIdMultipleItem.push(el['id'])
            })
            this.jsonFormSetting['multipleItem'] = this.arrIdMultipleItem
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/setting/behavior/modal-detail-behavior-form-setting/modal-detail-behavior-form-setting.component.ts